import { PublicModulesRouteMap } from '@/new-router/public-modules'
import { ProductCenterRouteMap } from '@/new-router/product-center'

const renderNodeList = () => import('@/views/Node/renderNodeList')
const rentNodeList = () => import('@/views/Node/rentNode')
const mirrorManagement = () => import('@/views/Node/mirrorManagement')
const nodeMachineChecklist = () => import('@/views/Node/nodeMachineChecklist')
const hardwareConfiguration = () => import('@/views/Node/hardwareConfiguration')
const hardwareModelToPerformance = () => import('@/views/Node/hardwareModelToPerformance')
const Home = () => import('@/views/Home/home')

/**
* hidden: true                   是否显示在侧栏上
  nocache: true                  组件将不keep-alive
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
  }
**/

export default [
  {
    path: '/node',
    name: 'node',
    component: Home,
    meta: {
      title: '节点机管理',
      icon: 'icon-node',
      showSubiems: false,
      sort: 6,
      modules: 'node',
      permission: 'node:root',
    },
    children: [
      {
        path: 'renderNodeList',
        name: 'renderNodeList',
        component: renderNodeList,
        meta: {
          title: '渲染节点机列表',
          active: ['renderNodeList'],
          permission: 'node:list',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.AnimationRendering, ProductCenterRouteMap.NodeManagement],
        },
      }, {
        path: 'rentNodeList',
        name: 'rentNodeList',
        component: rentNodeList,
        meta: {
          title: '租赁节点机列表',
          active: ['rentNodeList'],
          permission: 'rent:node:list',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.AnimationRendering, ProductCenterRouteMap.NodeManagement],
        },
      }, {
        path: 'mirrorManagement',
        name: 'mirrorManagement',
        component: mirrorManagement,
        meta: {
          title: '镜像管理',
          active: ['mirrorManagement'],
          permission: 'mirror:list',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.AnimationRendering, ProductCenterRouteMap.NodeManagement],
        },
      }, {
        path: 'nodeMachineChecklist',
        name: 'nodeMachineChecklist',
        component: nodeMachineChecklist,
        meta: {
          title: '节点机核对单',
          active: ['nodeMachineChecklist'],
          permission: 'node:check:list',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.AnimationRendering, ProductCenterRouteMap.NodeManagement],
        },
      }, {
        path: 'hardwareModelToPerformance',
        name: 'hardwareModelToPerformance',
        component: hardwareModelToPerformance,
        meta: {
          title: '硬件型号与性能系数表',
          active: ['hardwareModelToPerformance'],
          permission: 'hardware:mode',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.BillingConfiguration],
        },
      }, {
        path: 'hardwareConfiguration',
        name: 'hardwareConfiguration',
        component: hardwareConfiguration,
        meta: {
          title: '扣费硬件配置表',
          active: ['hardwareConfiguration'],
          permission: 'hardware:config:list',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.BillingConfiguration],
        },
      },
    ],
  },
]
